import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { defineAsyncComponent } from "vue";
import { useActivity } from "./hooks/useActivity";


export default /*#__PURE__*/_defineComponent({
  __name: 'Activity',
  setup(__props) {

const ActivityTab = defineAsyncComponent(
  () => import("@/components/activity/ActivityTab.vue")
);
const TerminalTab = defineAsyncComponent(
  () => import("@/components/terminal/TerminalTab.vue")
);
const RoleTab = defineAsyncComponent(
  () => import("@/components/role/RoleTab.vue")
);

const { active, saveActive, noActivity, permissions } = useActivity();

return (_ctx: any,_cache: any) => {
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!

  return (_unref(permissions).activityOnly)
    ? (_openBlock(), _createBlock(_unref(ActivityTab), { key: 0 }))
    : (_openBlock(), _createBlock(_component_TabView, {
        key: 1,
        lazy: "",
        "active-index": _unref(active),
        "onUpdate:activeIndex": _unref(saveActive)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, {
            header: _ctx.$t('workspaceLayout.activity')
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ActivityTab))
            ]),
            _: 1
          }, 8, ["header"]),
          (_unref(permissions).canReadTerminal)
            ? (_openBlock(), _createBlock(_component_TabPanel, {
                key: 0,
                disabled: _unref(noActivity),
                header: _ctx.$t('terminal.manage')
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(TerminalTab))
                ]),
                _: 1
              }, 8, ["disabled", "header"]))
            : _createCommentVNode("", true),
          (_unref(permissions).noRestriction)
            ? (_openBlock(), _createBlock(_component_TabPanel, {
                key: 1,
                disabled: _unref(noActivity),
                header: _ctx.$t('role.roles')
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(RoleTab))
                ]),
                _: 1
              }, 8, ["disabled", "header"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["active-index", "onUpdate:activeIndex"]))
}
}

})